import { Component } from "@angular/core";
import { ApiService } from "../shared/services/api.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.scss",
  standalone: false
})
export class LoaderComponent {
  private subscriptions: Subscription[] = [];
  counter: number = 0;

  constructor(public apiService: ApiService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apiService.apiLoading$.subscribe((isLoading) => {
        this.updateCounter(isLoading);
      })
    );
  }

  private updateCounter(isLoading: boolean): void {
    if (isLoading) {
      this.counter++;
    } else if (this.counter > 0) {
      this.counter--;
    }
  }
}
